import React from 'react';
import { useMsal, useIsAuthenticated, useAccount } from '@azure/msal-react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

import AccountCircle from '@mui/icons-material/AccountCircle';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAuth } from './auth';

const LoginMenu = () => {
  const { instance, accounts } = useMsal();
  const {isAuthenticated, getToken, logout} = useAuth();
  const user = getToken() as {[key: string]: string;} || []; //account?.name || 'User';
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateToProfile = () => {
    window.location.href = "/profile"; // Adjust the path as needed
  };

  return (
    <Box sx={{ marginLeft: "auto", marginRight: "12px", pt: "4px" }}>

      {isAuthenticated() && (
        <>
          <Button
            sx={{ color: "white", mr: "12px;", mt: "4px" }}
            disableElevation
            onClick={handleClick}
            startIcon={<AccountCircle />}
            endIcon={<KeyboardArrowDownIcon />}
          >
            {user['fullName']}
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={() => { handleClose(); navigateToProfile(); }} disableRipple>
              <AccountCircle sx={{ mr: 1 }} />
              User Profile
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem onClick={() => { handleClose(); logout(); }} disableRipple>
              <LogoutIcon sx={{ mr: 1 }} />
              Logout
            </MenuItem>
          </Menu>
        </>
      )}
    </Box>
  );
}

export default LoginMenu;